import { Box, Checkbox, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useAwardSelection } from "./AwardSelectionContext";
import { DocumentationNoteField } from "./DocumentationNoteField";
import { useWinnerDocumentationTexts } from "./useWinnerDocumentationTexts";
import type { WinnerDocumentationRule } from "../../../autogen/bff-api";

export const WinnerDocumentationStatement = ({
  suppliers,
  rule,
}: {
  suppliers: string[];
  rule: WinnerDocumentationRule | undefined;
}) => {
  const { documentationChecked, setDocumentationChecked, documentationNote, setDocumentationNote } =
    useAwardSelection();
  return (
    <WinnerDocumentationStatementFields
      suppliers={suppliers}
      rule={rule}
      checked={documentationChecked}
      onCheckedChange={setDocumentationChecked}
      note={documentationNote}
      onNoteChange={setDocumentationNote}
    />
  );
};

export const WinnerDocumentationStatementFields = ({
  suppliers,
  rule,
  checked,
  onCheckedChange,
  note,
  onNoteChange,
}: {
  suppliers: string[];
  rule: WinnerDocumentationRule | undefined;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  note: string;
  onNoteChange: (note: string) => void;
}) => {
  const { t } = useTranslation();
  const texts = useWinnerDocumentationTexts(rule);
  return (
    <Box mt="3" p="4" rounded="md" border="1px solid" borderColor="smBorder" bg="smBackground">
      <Checkbox colorScheme="teal" isChecked={checked} onChange={(e) => onCheckedChange(e.target.checked)}>
        <Text fontSize="sm">{texts.statement(suppliers.join(", "))}</Text>
      </Checkbox>
      <Text fontSize="xs" color="smMuted" mt="1" ml="6">
        {t("This goes into the procurement protocol and can't be withdrawn.")}
      </Text>
      {checked && <DocumentationNoteField note={note} onChange={onNoteChange} mt="3" />}
    </Box>
  );
};
